// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-module--wrapper--1i51Q","container":"footer-module--container--2Y5FL","list":"footer-module--list--8GHh5","listItem":"footer-module--listItem--23G-O"};